'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const GAME_TYPE = {
    MCQ: 'mcq',
    ERROR_TEXT: 'error-text',
    OPEN_QUESTION: 'open-question',
    NO_INTERACTION: 'no-interaction',
    PICTURE_SPOT: 'picture-spot',
    ORDERING_CARDS: 'ordering-cards',
    SWIPING_CARDS: 'swiping-cards',
};
const isGameMultipleChoiceQuestion = (game) => game.type === GAME_TYPE.MCQ;
const isGameErrorText = (game) => game.type === GAME_TYPE.ERROR_TEXT;
const isGameOpenQuestion = (game) => game.type === GAME_TYPE.OPEN_QUESTION;
const isGameNoInteraction = (game) => game.type === GAME_TYPE.NO_INTERACTION;
const isGamePictureSpot = (game) => game.type === GAME_TYPE.PICTURE_SPOT;
const isGameOrderingCards = (game) => game.type === GAME_TYPE.ORDERING_CARDS;
const isGameSwipingCards = (game) => game.type === GAME_TYPE.SWIPING_CARDS;
const isPartialGameMultipleChoiceQuestion = (game) => game.type === GAME_TYPE.MCQ;
const isPartialGameErrorText = (game) => game.type === GAME_TYPE.ERROR_TEXT;
const isPartialGameOpenQuestion = (game) => game.type === GAME_TYPE.OPEN_QUESTION;
const isPartialGameNoInteraction = (game) => game.type === GAME_TYPE.NO_INTERACTION;
const isPartialGamePictureSpot = (game) => game.type === GAME_TYPE.PICTURE_SPOT;
const isPartialGameOrderingCards = (game) => game.type === GAME_TYPE.ORDERING_CARDS;
const isPartialGameSwipingCards = (game) => game.type === GAME_TYPE.SWIPING_CARDS;
const extractGameExplanation = (game) => {
    if (!game || game.type === 'no-interaction') {
        return undefined;
    }
    return game.explanation;
};
const extractExplanation = (content) => {
    return extractGameExplanation(content.game);
};
const extractImages = (game) => {
    var _a, _b, _c, _d;
    if (isGameOrderingCards(game)) {
        return [];
    }
    if (isGameNoInteraction(game)) {
        const images = [];
        if ((_a = game.firstMedia.image) === null || _a === void 0 ? void 0 : _a.url) {
            images.push(game.firstMedia.image.url);
        }
        if ((_b = game.secondMedia.image) === null || _b === void 0 ? void 0 : _b.url) {
            images.push(game.secondMedia.image.url);
        }
        return images;
    }
    if (isGamePictureSpot(game)) {
        return [game.image.url];
    }
    if (isGameSwipingCards(game)) {
        return game.cards.reduce((acc, card) => {
            var _a;
            if ((_a = card.image) === null || _a === void 0 ? void 0 : _a.url) {
                acc.push(card.image.url);
            }
            return acc;
        }, []);
    }
    const images = [];
    if ((_c = game.gameMedia.image) === null || _c === void 0 ? void 0 : _c.url) {
        images.push(game.gameMedia.image.url);
    }
    if ((_d = game.explanationMedia.image) === null || _d === void 0 ? void 0 : _d.url) {
        images.push(game.explanationMedia.image.url);
    }
    return images;
};

exports.GAME_TYPE = GAME_TYPE;
exports.extractExplanation = extractExplanation;
exports.extractGameExplanation = extractGameExplanation;
exports.extractImages = extractImages;
exports.isGameErrorText = isGameErrorText;
exports.isGameMultipleChoiceQuestion = isGameMultipleChoiceQuestion;
exports.isGameNoInteraction = isGameNoInteraction;
exports.isGameOpenQuestion = isGameOpenQuestion;
exports.isGameOrderingCards = isGameOrderingCards;
exports.isGamePictureSpot = isGamePictureSpot;
exports.isGameSwipingCards = isGameSwipingCards;
exports.isPartialGameErrorText = isPartialGameErrorText;
exports.isPartialGameMultipleChoiceQuestion = isPartialGameMultipleChoiceQuestion;
exports.isPartialGameNoInteraction = isPartialGameNoInteraction;
exports.isPartialGameOpenQuestion = isPartialGameOpenQuestion;
exports.isPartialGameOrderingCards = isPartialGameOrderingCards;
exports.isPartialGamePictureSpot = isPartialGamePictureSpot;
exports.isPartialGameSwipingCards = isPartialGameSwipingCards;
//# sourceMappingURL=content.js.map
